import { ArrowBack, ArrowForward, Download, Save } from "@mui/icons-material";
import {
  Alert,
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  Pagination,
  PaginationItem,
  Snackbar,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomDataGrid from "../CustomComponents/CustomDataGrid";
import NoDataFound from "../CustomComponents/NoDataFound";
import dayjs from "dayjs";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";
const NachRetrievalList = () => {
  //Selectors from redux store
  const datarows = useSelector((state) => state.nachRetrieval.gridRows);
  const filteredData = useSelector((state) => state.nachRetrieval.filterData);
  // Dialog msg content.
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogTitleMessage, setDialogTitleMessage] = useState("");
  //Maintainig State for Dialog while submitting the application
  const [open, setOpen] = useState(false);
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [spinnerLoadingMsg, setSpinnerLoadingMsg] = useState("");
  const columns = [
    {
      field: "applicationBranch",
      headerName: "Branch",
      headerAlign: "center",
      align: "left",
      flex: 200,
    },
    {
      field: "applicationNum",
      headerName: "Application Number",
      headerAlign: "center",
      align: "left",
      flex: 200,
    },
    {
      field: "customerName",
      headerName: "Applicant Name",
      headerAlign: "center",
      align: "left",
      flex: 200,
      renderCell: (params) => {
        return params.value.toUpperCase();
      },
    },
    {
      field: "bankName",
      headerName: "Drawee Bank",
      headerAlign: "center",
      align: "left",
      flex: 200,
    },
    {
      field: "mandateNum",
      headerName: "Mandate Number",
      headerAlign: "center",
      align: "left",
      flex: 210,
    },
    {
      field: "umrnNumber",
      headerName: "UMRN Number",
      headerAlign: "center",
      align: "right",
      flex: 215,
    },
  ];

  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [savedDialog, setSavedDialog] = useState(false);
  const [snackBarState, setSnackBarState] = React.useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);

  const [rows, setRows] = React.useState([]);
  const [accordianOpen, setAccordianOpen] = React.useState(true);
  const [page, setPage] = React.useState(1);
  const rowsPerPage = 10;
  const [totalPageCount, setTotalPageCount] = React.useState(0);
  const [totalRowsCount, setTotalRowsCount] = React.useState(0);
  const userName = useSelector((state) => state.branch.userName);

  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  useEffect(() => {
    setRows([...datarows].slice(0, 10));
    setTotalPageCount(
      datarows.length % 10 !== 0
        ? Number(Number((datarows.length / 10).toFixed()) + 1)
        : Number(Number((datarows.length / 10).toFixed()))
    );
    setTotalRowsCount(datarows.length);
    setPage(1);
  }, [datarows]);

  const handlePageChange = (event, newPage) => {
    let offset = (newPage - 1) * rowsPerPage;
    setPage(newPage);
    setRows([...datarows].slice(offset, offset + rowsPerPage));
  };

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };
  const saveNachHandler = () => {
    try {
      // get the branch Code based on branch.
      const branchWithCodes = GetBranchDetailsWithCode();
      const branchCodeValue = branchWithCodes.find((branch) => {
        return branch.label === filteredData.branchValue;
      });
      const mandateNums = datarows.map((row) => row.mandateNum);
      axios
        .post("/retrievalposting/saveNachRetrievalData", {
          branch: "",
          branchCode: "",
          mandateNum: mandateNums,
          draweeBank: filteredData.bankName,
          dueDate: dayjs(filteredData.dueDate).format("YYYY-MM-DD"),
          createdBy: userName,
          modifiedBy: userName,
        })
        .then((response) => {
          if (response.status === 200) {
            setSpinnerLoading(false);
            setSpinnerLoadingMsg("");
            setMessage(response.data);
            setAlertType("success");
            window.location.reload();
            openAlertHandler();
          } else if (response.status === 206) {
            setSpinnerLoading(false);
             setSpinnerLoadingMsg("");
            setMessage(response.data);
            setAlertType("error");
            openAlertHandler();
          }
        });
    } catch (error) {
      setSpinnerLoading(false);
       setSpinnerLoadingMsg("");
      setMessage("Failed to save NACH Retrieval Data.");
      setAlertType("error");
      openAlertHandler();
      throw Error(error);
    }
  };

  const openAlertDialog = () => {
    setDialogMessage("Are you sure want to save NACH Retrieval Data ?");
    setDialogTitleMessage("Confirmation");
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDownload = () => {
    try {
      const mandateNums = datarows.map((row) => row.mandateNum);
      axios
        .post(
          "/retrievalposting/downloadRetrievalExcel",
          {
            branch: "",
            mandateNum: mandateNums,
            draweeBank: filteredData.bankName,
            dueDate: dayjs(filteredData.dueDate).format("YYYY-MM-DD"),
          },
          {
            method: "POST",
            responseType: "blob",
          }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `NACH_Retrieval_` + new Date() + `.xls`
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setMessage("Downloaded NACH Retrieval Data Successfully.");
          setAlertType("success");
          openAlertHandler();
        });
    } catch (error) {
      setMessage("Failed to download NACH Retrieval Data.");
      setAlertType("error");
      openAlertHandler();
      throw Error(error);
    }
  };
  return (
    <AccordianContainer
      id="accord"
      title="NACH Retrieval Information"
      initialOpen={true}
      sx={{ margin: "8px !important" }}
    >
      {useMediaQuery("(min-width:1200px)") && (
        <React.Fragment>
          <Box
            sx={{
              float: "right",
              // margin: "8px 0px 8px 0px",
            }}
          >
            <Button
              disabled={datarows.length <= 0}
              variant="contained"
              sx={{ margin: "8px" }}
              // onClick={}
              onClick={() => {
                handleDownload();
              }}
            >
              Download
            </Button>
            <Button
              disabled={datarows.length <= 0}
              sx={{ margin: "8px" }}
              variant="contained"
              // onClick={}
              onClick={() => {
                openAlertDialog();
              }}
            >
              Save
            </Button>
          </Box>
          <CustomDataGrid
            noDataMessage="No NACH Retrieval Data."
            noDataOnFilterMessage="No NACH Retrieval Data on Applied Filter."
            rows={datarows}
            rowHeight={40}
            gridHeight={
              datarows.length < 5 && datarows.length !== 0
                ? datarows.length * 40 + 130
                : 330
            }
            columns={columns}
            pageSize={10}
            pageSizeOptions={[10]}
            gridLazyLoad={() => {}}
            onSortModelChange={() => {}}
          />
        </React.Fragment>
      )}
      {useMediaQuery("(max-width:1200px)") && (
        <React.Fragment>
          <Box
            sx={{
              float: "right",
              //margin: "8px 0px 8px 0px",
            }}
          >
            <Button
              disabled={datarows.length <= 0}
              variant="contained"
              sx={{ margin: "8px" }}
              // onClick={}
              onClick={() => {
                handleDownload();
              }}
            >
              <Download />
            </Button>
            <Button
              disabled={datarows.length <= 0}
              sx={{ margin: "8px" }}
              variant="contained"
              // onClick={}
              onClick={() => {
                openAlertDialog();
              }}
            >
              <Save />
            </Button>
          </Box>
          <Grid
            container
            item
            direction="row"
            alignItems="flex-end"
            justifyContent="flex-end"
            sx={{ height: "60px", bgcolor: "white" }}
          >
            {totalRowsCount > 10 && (
              <Typography
                sx={{
                  mr: 2,
                  color: "#004A92",
                  fontWeight: 700,
                }}
              >
                {"Page Max Records : " + rowsPerPage}
              </Typography>
            )}
            <Typography
              padding="1px"
              sx={{ color: "#004A92", fontWeight: 700 }}
            >
              {"Total Records : " + totalRowsCount}
            </Typography>
            <Pagination
              count={totalPageCount}
              color="primary"
              onChange={handlePageChange}
              page={page}
              renderItem={(item) => (
                <PaginationItem
                  slots={{ previous: ArrowBack, next: ArrowForward }}
                  {...item}
                />
              )}
            />
          </Grid>
          <Grid container>
            <Box
              sx={{
                height: accordianOpen
                  ? window.innerHeight - 540
                  : window.innerHeight - 250,
                overflow: "auto",
                flex: "1 auto",
              }}
            >
              {rows.map((row, index) => (
                <React.Fragment>
                  <Grid container direction="column" sx={{ flex: "1 auto" }}>
                    <Card>
                      <CardHeader
                        subheader={"Application Number : " + row.applicationNum}
                        subheaderTypographyProps={{
                          color: "#004A92",
                          fontWeight: "700",
                        }}
                        sx={{
                          textAlign: "left",
                          padding: "16px 16px 0px 16px !important",
                        }}
                      />
                      <CardContent sx={{}}>
                        <Grid
                          container
                          item
                          direction="column"
                          alignItems="flex-start"
                          justifyContent="flex-start"
                          sx={{}}
                        >
                          <Grid
                            container
                            direction="row"
                            alignItems="flex-start"
                            justifyContent="flex-start"
                          >
                            <Grid item xs={7} md={5}>
                              <Typography padding="1px">{"Branch"}</Typography>
                            </Grid>
                            <Grid item xs={5} md={7}>
                              {` :  ${row.applicationBranch}`}
                            </Grid>
                            <Grid item xs={7} md={5}>
                              <Typography padding="1px">
                                {"Applicant Name"}
                              </Typography>
                            </Grid>
                            <Grid item xs={5} md={7}>
                              {` :  ${row.customerName}`}
                            </Grid>
                            <Grid item xs={7} md={5}>
                              <Typography padding="1px">
                                {"Drawee Bank"}
                              </Typography>
                            </Grid>
                            <Grid item xs={5} md={7}>
                              {` :  ${row.bankName}`}
                            </Grid>
                            <Grid item xs={7} md={5}>
                              <Typography padding="1px">
                                {"Mandate Number"}
                              </Typography>
                            </Grid>
                            <Grid item xs={5} md={7}>
                              {` :  ${row.mandateNum}`}
                            </Grid>
                            <Grid item xs={7} md={5}>
                              <Typography padding="1px">
                                {"UMRN Number"}
                              </Typography>
                            </Grid>
                            <Grid item xs={5} md={7}>
                              {` :  ${row.umrnNumber}`}
                            </Grid>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Divider />
                </React.Fragment>
              ))}
              {rows.length === 0 && (
                <NoDataFound
                  message={"No NACH Retrieval Record Found."}
                  imageStyle={{
                    marginTop:
                      accordianOpen && window.innerHeight < 1000
                        ? "20px"
                        : "20%",
                  }}
                />
              )}
            </Box>
          </Grid>
        </React.Fragment>
      )}

      <Snackbar
        open={alert}
        autoHideDuration={3000}
        anchorOrigin={{ vertical, horizontal }}
        onClose={closeAlertHandler}
      >
        <Alert
          onClose={closeAlertHandler}
          severity={alertType}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <Dialog open={open} aria-describedby="alert-dialog-slide-description">
        <DialogTitle>{dialogTitleMessage}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {dialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+Q" placement="top">
            <Button onClick={handleClose}>Cancel</Button>
          </Tooltip>
          <Tooltip title="Ctrl+Y" placement="top">
            <Button
              onClick={() => {
                setOpen(false);
                setSpinnerLoadingMsg("Saving NACH Retrieved Records ....");
                setTimeout(() => {
                  setSpinnerLoading(true);
                  saveNachHandler();
                }, 1000);
              }}
            >
              Yes
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      {spinnerLoading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              alignItems: "center",
            }}
          >
            <CircularProgress color="inherit" />
            <p>{spinnerLoadingMsg}</p>
          </Box>
        </Backdrop>
      )}
    </AccordianContainer>
  );
};

export default NachRetrievalList;
